import { OneDayInMs } from '@shared/constants/times/one-day-in-ms'

export const OneMonthInMs: number = 30 * OneDayInMs
